var FcCustomSelectModule = /** @class */ (function () {
    function FcCustomSelectModule() {
    }
    return FcCustomSelectModule;
}());
export { FcCustomSelectModule };
